import { render, staticRenderFns } from "./sendTableList.vue?vue&type=template&id=273e2d50&scoped=true"
import script from "./sendTableList.vue?vue&type=script&lang=js"
export * from "./sendTableList.vue?vue&type=script&lang=js"
import style0 from "./sendTableList.vue?vue&type=style&index=0&id=273e2d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e2d50",
  null
  
)

export default component.exports